import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Lock, Phone, Mail, MapPin } from 'lucide-react';
import { SourceInfo } from './SourceInfo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Alleen voor admin: wie heeft deze motor geplaatst.
export const OriginCard = ({ motorcycleId }) => {
  const [o, setO] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/motorcycles/${motorcycleId}/origin`).then((r) => setO(r.data)).catch(() => setO(null));
  }, [motorcycleId]);
  if (!o) return null;
  const s = o.supplier;
  const who = s ? (s.company_name || s.name) : o.supplier_company;
  const place = s ? [s.address, `${s.postal_code || ''} ${s.city || ''}`.trim(), s.country].filter(Boolean).join(', ') : '';
  return (
    <div className="mt-6 bg-purple-50 border border-purple-200 rounded-xl p-4 text-sm text-purple-950" data-testid="origin-card">
      <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-purple-800 mb-2">
        <Lock className="w-3.5 h-3.5" /> Herkomst (alleen admin)
      </div>
      {who ? (
        <>
          <div className="text-base font-semibold" data-testid="origin-supplier">Geplaatst door: {who}</div>
          {s?.name && s.name !== who && <div className="text-xs text-purple-800">Contact: {s.name}</div>}
          <div className="mt-2 space-y-1 text-xs">
            {place && <div className="flex gap-1.5"><MapPin className="w-3.5 h-3.5 shrink-0" />{place}</div>}
            {s?.phone && <a href={`tel:${s.phone}`} className="flex gap-1.5 underline" data-testid="origin-phone"><Phone className="w-3.5 h-3.5" />{s.phone}</a>}
            {s?.email && <a href={`mailto:${s.email}`} className="flex gap-1.5 underline break-all" data-testid="origin-email"><Mail className="w-3.5 h-3.5" />{s.email}</a>}
          </div>
        </>
      ) : (
        <div data-testid="origin-supplier">
          Geplaatst door: {o.creator ? `${o.creator.company_name || o.creator.name || o.creator.email} (${o.creator.role === 'admin' ? 'admin' : o.creator.role})` : 'onbekend'}
        </div>
      )}
      {o.created_at && <div className="text-[11px] text-purple-700 mt-2">Geplaatst op {new Date(o.created_at).toLocaleDateString('nl-NL')}</div>}
      {o.motoscout && <div className="mt-3"><SourceInfo source={o.motoscout} motorcycleId={motorcycleId} /></div>}
    </div>
  );
};
